import { useIsDesktop, WSScreen } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { AccountTab } from "./AccountTab";
import { AddTeamMember } from "./AddTeamMember";
import { BusinessInfoTab } from "./BusinessInfoTab";
import { Developer } from "./Developer";
import { EditTeamMember } from "./EditTeamMember";
import { IntegrationsTab } from "./Integrations/IntegrationsTab";
import { IntegrationsQuickbooksSyncActivities } from "./Integrations/quickbooks/IntegrationsQuickbooksSyncActivities";
import { QuickbooksSetupStep1 } from "./Integrations/quickbooks/QuickbooksSetupStep1";
import { QuickbooksSetupStep2 } from "./Integrations/quickbooks/QuickbooksSetupStep2";
import { QuickbooksSetupStep3 } from "./Integrations/quickbooks/QuickbooksSetupStep3";
import { QuickbooksSetupStep4 } from "./Integrations/quickbooks/QuickbooksSetupStep4";
import { QuickbooksSetupStep5 } from "./Integrations/quickbooks/QuickbooksSetupStep5";
import { QuickbooksSetupStep6 } from "./Integrations/quickbooks/QuickbooksSetupStep6";
import { QuickbooksSetupStep7 } from "./Integrations/quickbooks/QuickbooksSetupStep7";
import { QuickbooksSetupStep8 } from "./Integrations/quickbooks/QuickbooksSetupStep8";
import { NotificationsTab } from "./NotificationsTab";
import { PaymentMethods } from "./PaymentMethods";
import { Payroll } from "./Payroll";
import { PersonalInformationTab } from "./PersonalInformationTab";
import { TaxProfileTab } from "./TaxProfileTab";
import { TeamTab } from "./TeamTab";

export type SettingsProps = RouteComponentProps;

export const SettingsMain: React.FC<SettingsProps> = () => {
  const isDesktop = useIsDesktop();

  return (
    <Switch>
      <Route path="/member/settings/account" component={AccountTab} />
      <Route
        path="/member/settings/personal-info"
        component={PersonalInformationTab}
      />
      <Route
        path="/member/settings/business-info"
        component={BusinessInfoTab}
      />
      {/* Integrations */}
      <Redirect
        path="/member/settings/integrations/quickbooks/setup"
        exact
        to="/member/settings/integrations/quickbooks/setup/step/1"
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/1"
        exact
        component={QuickbooksSetupStep1}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/2"
        exact
        component={QuickbooksSetupStep2}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/3"
        exact
        component={QuickbooksSetupStep3}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/4"
        exact
        component={QuickbooksSetupStep4}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/5"
        exact
        component={QuickbooksSetupStep5}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/6"
        exact
        component={QuickbooksSetupStep6}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/7"
        exact
        component={QuickbooksSetupStep7}
      />
      <Route
        path="/member/settings/integrations/quickbooks/setup/step/8"
        exact
        component={QuickbooksSetupStep8}
      />
      <Route
        path="/member/settings/integrations/quickbooks/history"
        exact
        component={IntegrationsQuickbooksSyncActivities}
      />
      <Route path="/member/settings/integrations" component={IntegrationsTab} />

      {/* Everythings else */}

      <Route path="/member/settings/payroll" component={Payroll} />

      <Route path="/member/settings/tax-profile" component={TaxProfileTab} />
      <Route
        path="/member/settings/notifications"
        component={NotificationsTab}
      />
      <Route
        path="/member/settings/team"
        exact={!isDesktop}
        component={TeamTab}
      />
      {!isDesktop && (
        <Route
          key="add-team-member"
          exact
          path="/member/settings/team/add-team-member"
          component={AddTeamMember}
        />
      )}
      {!isDesktop && (
        <Route
          key="edit-team-member"
          path="/member/settings/team/edit-team-member"
          exact
          component={EditTeamMember}
        />
      )}
      <Route
        path="/member/settings/tokens"
        exact={!isDesktop}
        component={Developer}
      />
      <Route
        path="/member/settings/payment-methods"
        component={PaymentMethods}
      />
      <WSScreen.Desktop>
        <Redirect from="/member/settings" exact to="/member/settings/account" />
      </WSScreen.Desktop>
    </Switch>
  );
};
